<template>
  <div style="width: 100%; height: 100%">
    <div class="ddBar" style="width: 100%; height: 100%"></div>
  </div>
</template>

<script>
// const echarts = require('echarts/lib/echarts')
// require('echarts/lib/component/tooltip')
// require('echarts/lib/component/legend')
// require('echarts/lib/chart/pie')
import * as echarts from 'echarts'
// var charts = {}
export default {
  props: {
    chartData: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      chart: {}
    }
  },
  watch: {
    chartData: {
      handler (val) {
        this.updateCharts()
      },
      deep: true
    }
  },
  mounted () {
    this.chart = echarts.init(document.querySelector('.ddBar'))
    // 根据浏览器宽度变化改变可视化报表图宽高
    // window.addEventListener('resize', () => {
    //   this.chart.resize()
    // })
  },
  methods: {
    updateCharts () {
      const series = this.chartData.map(item => ({
        type: 'bar',
        stack: 'Ad',
        emphasis: {
          focus: 'series'
        },
        ...item }))
      this.chart.setOption({
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'cross',
            crossStyle: {
              color: '#999'
            }
          },
          valueFormatter: function (value) {
            return value + 't'
          }
        },
        toolbox: {
          feature: {
            // dataView: { show: true, readOnly: false },
            // magicType: { show: true, type: ['line', 'bar'] },
            // restore: { show: true },
            // saveAsImage: { show: true }
          }
        },
        legend: {
          // orient: 'vertical',
          top: '3%',
          textStyle: {
            color: 'white',
            fontSize: '14px'
          }
        },
        xAxis: [
          {
            type: 'category',
            data: [
              '一月',
              '二月',
              '三月',
              '四月',
              '五月',
              '六月',
              '七月',
              '八月',
              '九月',
              '十月',
              '十一月',
              '十二月'
            ],
            axisPointer: {
              type: 'shadow'
            },
            axisLabel: {
              color: '#fff'
            }
          }
        ],
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },

        yAxis: [
          {
            type: 'value',
            axisLabel: {
              color: '#fff'
            }
          }

        ],
        series
        // series: [
        //   {
        //     name: '成品油',
        //     type: 'bar',
        //     stack: 'Ad',
        //     emphasis: {
        //       focus: 'series'
        //     },
        //     data: [120, 132, 101, 134, 90, 230, 210, 132, 101, 134, 90, 230]
        //   },
        //   {
        //     name: '碳材料',
        //     type: 'bar',
        //     stack: 'Ad',
        //     emphasis: {
        //       focus: 'series'
        //     },
        //     data: [220, 182, 191, 234, 290, 330, 310, 182, 191, 234, 290, 330]
        //   },
        //   {
        //     name: '化工品',
        //     type: 'bar',
        //     stack: 'Ad',
        //     emphasis: {
        //       focus: 'series'
        //     },
        //     data: [150, 232, 201, 154, 190, 330, 410, 150, 232, 201, 190, 330]
        //   },
        //   {
        //     name: '聚烯烃',
        //     type: 'bar',
        //     stack: 'Ad',
        //     emphasis: {
        //       focus: 'series'
        //     },
        //     data: [150, 232, 201, 154, 190, 330, 410, 201, 154, 190, 150, 232]
        //   },
        //   {
        //     name: '沥青',
        //     type: 'bar',
        //     stack: 'Ad',
        //     emphasis: {
        //       focus: 'series'
        //     },
        //     data: [150, 232, 201, 154, 190, 330, 410, 201, 154, 190, 330, 410]
        //   }

        // ]
      })
    }
  }
}
</script>

<style scoped lang="scss"></style>
